import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { PurchaseItemResponse } from '@Types/api/form';
import { RequestFormHeader } from '@Types/index';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MaterialRequestState {
  purchaseRequest: RequestFormHeader;
  purchaseOverviewItems: PurchaseItemResponse[];
  selectedOverviewItems: PurchaseItemResponse[];
  createdTenderId: number;
}

const initialState: MaterialRequestState = {
  purchaseRequest: getDefaultRequestState(),
  purchaseOverviewItems: [],
  selectedOverviewItems: [],
  createdTenderId: 0,
};

const purchaseRequestSlice = createSlice({
  name: 'purchaseRequest',
  initialState,
  reducers: {
    setPurchaseRequest: (
      state: MaterialRequestState,
      action: PayloadAction<RequestFormHeader>
    ) => {
      state.purchaseRequest = action.payload;
    },
    setSelectedOverviewItem: (
      state: MaterialRequestState,
      action: PayloadAction<PurchaseItemResponse>
    ) => {
      state.selectedOverviewItems.push(action.payload);
    },
    setUnselectedOverviewItem: (
      state: MaterialRequestState,
      action: PayloadAction<PurchaseItemResponse>
    ) => {
      const updatedItems = state.selectedOverviewItems.filter(
        (item) => item?.reqItemId !== action.payload?.reqItemId
      );
      state.selectedOverviewItems = updatedItems;
    },
    selectAllOverviewItems: (state: MaterialRequestState) => {
      state.selectedOverviewItems = state.purchaseOverviewItems;
    },
    unselectAllOverviewItems: (state: MaterialRequestState) => {
      state.selectedOverviewItems = [];
    },
    addOverviewItem: (
      state: MaterialRequestState,
      action: PayloadAction<PurchaseItemResponse>
    ) => {
      state.purchaseOverviewItems.push(action.payload);
    },
    removeOverviewItem: (
      state: MaterialRequestState,
      action: PayloadAction<PurchaseItemResponse>
    ) => {
      const updatedItems = state.purchaseOverviewItems.filter(
        (item) => item?.reqItemId !== action.payload?.reqItemId
      );

      const filterItems = state.selectedOverviewItems.filter(
        (item) => item?.reqItemId !== action.payload?.reqItemId
      );

      state.purchaseOverviewItems = updatedItems;
      state.selectedOverviewItems = filterItems;
    },
    removeAllOverviewItem: (state: MaterialRequestState) => {
      state.purchaseOverviewItems = [];
      state.selectedOverviewItems = [];
    },
    setCreatedTenderId: (state, action: PayloadAction<number>) => {
      state.createdTenderId = action.payload;
    },
    clearBasket: (state) => {
      state.purchaseRequest = getDefaultRequestState();
      state.purchaseOverviewItems = [];
      state.selectedOverviewItems = [];
      state.createdTenderId = 0;
    },
  },
});

const { actions } = purchaseRequestSlice;

export const purchaseRequestActions = {
  ...actions,
};

export default purchaseRequestSlice;
